module.exports = __webpack_public_path__ + "static/sapin-sapin-efb196e7a56558aa91aa38c4fa7e27ce.jpg";